<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="text-right" v-if="$can('admin:admin')">
        <v-btn color="primary" :to="{ name: 'roles.create' }">
          Novo perfil
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-text-field label="Filtrar..." v-model="searchTerm" hide-details />
      </v-col>

      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="filteredRoles"
          v-model:page="page"
          :items-per-page="perPage"
          :items-length="totalItems"
          :items-per-page-options="[{ value: 10, title: '10' }]"
          :loading="isLoading"
          @click:row="onEditRole"
        >
          <template v-slot:item.is_master="{ item }">
            <span v-if="item.is_master"> Sim </span>
            <span v-else> Não </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useRolesQuery } from "@/queries/modules/roles";
import { useSnackbar } from "@/plugins/snackbar";

const route = useRoute();
const router = useRouter();
const snackbar = useSnackbar();

const page = ref(1);
const perPage = ref(10);
const searchTerm = ref("");
const context = ref("");

const headers = [
  { title: "Perfil", key: "description" },
  { title: "Admin", key: "is_master" },
];

// Query params - reactive to page changes
const queryParams = computed(() => ({
  type: context.value,
  limit: perPage.value,
  offset: (page.value - 1) * perPage.value,
}));

// Use TanStack Query for roles
const {
  data: rolesData,
  isLoading,
  error,
  refetch,
} = useRolesQuery(queryParams);

// Computed properties
const roles = computed(() => rolesData.value?.items || []);
const totalItems = computed(() => rolesData.value?.total || 0);

const filteredRoles = computed(() => {
  return roles.value.filter((role) => {
    return role.description
      .toLowerCase()
      .includes(searchTerm.value.toLowerCase());
  });
});

// Methods
const onEditRole = (event, { item }) => {
  router.push({
    name: "roles.edit",
    params: { role_id: item.id },
  });
};

// Watch for errors
watch(error, (err) => {
  if (err) {
    snackbar.error(err.message);
  }
});

// Initialize context on mount
onMounted(() => {
  context.value = route.meta.context;

  if (context.value !== "vendor") {
    throw new Error(`Invalid role context: ${context.value}`);
  }
});
</script>
